import React from 'react';
import { Button } from '../../../components/ui/Button';
import { AppIcon } from '../../../components/icons/AppIcon';

type Props = {
  onGoToChat: () => void;
};

const OnboardingCompleteStep: React.FC<Props> = ({ onGoToChat }) => (
  <section
    aria-labelledby="onboarding-step-title"
    className="flex flex-col items-center text-center"
  >
    <div
      className="mb-s5 flex size-14 items-center justify-center rounded-2xl bg-success-bg text-success-text"
      aria-hidden
    >
      <AppIcon name="check-circle" className="size-7" />
    </div>

    <h1
      id="onboarding-step-title"
      className="text-balance text-xl font-semibold tracking-tight text-default sm:text-2xl lg:text-3xl"
    >
      Tudo pronto
    </h1>
    <p className="mx-auto mt-s2 max-w-md text-pretty text-sm text-muted sm:text-base">
      Sua conta está configurada. Abra as conversas e comece a atender leads no WhatsApp.
    </p>

    <Button
      type="button"
      size="lg"
      className="mt-s6 min-h-11 w-full touch-manipulation hover:shadow-brand sm:w-auto sm:min-w-56"
      onClick={onGoToChat}
    >
      Ir para conversas
    </Button>
  </section>
);

export default OnboardingCompleteStep;
